/**
 * This is a provider, so no story makes sense for this component
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponentWithChildren } from 'src/utils/types';
import { MaybeLoanID } from 'src/common/types';
import { useDatadogProviderState } from './hooks/useDatadogProviderState';

/**
 * Sets the current user data for the datadog session. This must wrap every single experience to ensure that each
 * page has user data for it's datadog telemetry.
 */
export const DatadogProvider: FunctionComponentWithChildren<{ loanID?: MaybeLoanID }> = ({ children, loanID }) => {
    useDatadogProviderState(loanID);

    return <>{children}</>;
};
